"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var abstractComponent_1 = __importDefault(require("./abstractComponent"));
var constants_1 = require("../data/constants");
var Projectinquiry_1 = __importDefault(require("./Forms/Projectinquiry"));
var Application_1 = __importDefault(require("./Forms/Application"));
var app_1 = __importDefault(require("../services/app"));
var IndexedDb_1 = __importDefault(require("../services/IndexedDb"));
var Form = /** @class */ (function (_super) {
    __extends(Form, _super);
    function Form() {
        var _this = _super.call(this, constants_1.DATA_FORM) || this;
        _this.txForm = 'tx_form_formframework';
        new app_1.default();
        _this.database = new IndexedDb_1.default();
        Form.element = _this.getElement();
        if (!Form.element) {
            return _this;
        }
        Form.type = Form.element.dataset.form;
        Form.back = _this.getChildElement("[".concat(constants_1.DATA_FORM_BACK));
        _this.setValidationSchema();
        _this.activeStep = _this.getCurrentPage() - 1;
        var inputFiles = Form.getField('files');
        Form.allowedFileTypes = inputFiles ? inputFiles.accept : '';
        // Wofür ist das sinnvoll?
        _this.previousListener();
        _this.submitHandler();
        _this.revalidateInputs();
        return _this;
    }
    Form.prototype.previousListener = function () {
        var _a;
        (_a = Form.back) === null || _a === void 0 ? void 0 : _a.addEventListener('click', function () {
            sessionStorage.setItem('back', 'true');
        });
    };
    Form.prototype.revalidateInputs = function () {
        var _this = this;
        var _a;
        Form.inputs = this.getChildElements('input, textarea, select');
        (_a = Form.inputs) === null || _a === void 0 ? void 0 : _a.forEach(function (element) {
            var fieldWrap = element.closest("[".concat(constants_1.DATA_FORM_FIELD_WRAP, "]"));
            if (!fieldWrap)
                return;
            if (!fieldWrap.classList.contains('has-error'))
                return;
            var identifier = element.id.replace("".concat(Form.element.id, "-"), '');
            var validationSchema = _this.validationSchema[_this.activeStep].fields[identifier];
            if (element.type === 'text' || element.type === 'email' || element.type === 'tel' || element.type === 'number' || element.nodeName === 'TEXTAREA') {
                element === null || element === void 0 ? void 0 : element.addEventListener('keyup', function () { return Form.checkValidity(validationSchema, Form.getValue(identifier), fieldWrap); });
            }
            if (element.type === 'checkbox' || element.type === 'radio') {
                element === null || element === void 0 ? void 0 : element.addEventListener('change', function () { return Form.checkValidity(validationSchema, Form.getChecked(identifier), fieldWrap); });
            }
            if (element.type === 'number' || element.type === 'date' || element.nodeName === 'SELECT') {
                element === null || element === void 0 ? void 0 : element.addEventListener('change', function () { return Form.checkValidity(validationSchema, Form.getValue(identifier), fieldWrap); });
            }
            if (element.type === 'file') {
                element === null || element === void 0 ? void 0 : element.addEventListener('change', function (e) {
                    var target = e.target;
                    Form.checkValidity(validationSchema, Form.getFiles(identifier, target), fieldWrap);
                });
            }
        });
    };
    Form.checkValidity = function (validationSchema, validate, fieldWrap) {
        var _this = this;
        var fieldError = fieldWrap.querySelector("[".concat(constants_1.DATA_FORM_FIELD_ERROR, "]"));
        validationSchema.validate(validate)
            .then(function () {
            fieldError.classList.add('d-none');
            fieldWrap.classList.remove('has-error');
        })
            .catch(function (error) { return _this.setError(error, fieldWrap, fieldError); });
    };
    Form.prototype.setValidationSchema = function () {
        Form.errorMessages = JSON.parse(Form.element.dataset.errorMessages);
        if (Form.type === 'Application') {
            this.validationSchema = Application_1.default.setValidationSchema();
        }
        if (Form.type === 'Projectinquiry') {
            this.validationSchema = Projectinquiry_1.default.setValidationSchema();
        }
    };
    Form.prototype.getCurrentPage = function () {
        var button = Form.element.querySelector("button[name='".concat(this.txForm, "[").concat(Form.element.id, "][__currentPage]']"));
        return parseInt(button.value);
    };
    Form.getField = function (string) {
        return this.element.querySelector("[id='".concat(this.element.id, "-").concat(string, "']"));
    };
    Form.getFieldWrap = function (string) {
        var field = this.getField(string);
        return field.closest("[".concat(constants_1.DATA_FORM_FIELD_WRAP, "]"));
    };
    Form.prototype.submitHandler = function () {
        var _this = this;
        var _a;
        (_a = Form.element) === null || _a === void 0 ? void 0 : _a.addEventListener('submit', function (e) { return _this.validateObject(e); });
    };
    Form.prototype.validateObject = function (event) {
        var _this = this;
        var currentValidationSchema = this.validationSchema[this.activeStep];
        var currentFormValues;
        if (Form.type === 'Application') {
            currentFormValues = Application_1.default.getValues()[this.activeStep];
        }
        if (Form.type === 'Projectinquiry') {
            currentFormValues = Projectinquiry_1.default.getValues()[this.activeStep];
        }
        currentValidationSchema.validate(currentFormValues, { abortEarly: false })
            .then(function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.activeStep === this.validationSchema.length - 1)) return [3 /*break*/, 2];
                        sessionStorage.setItem('formSent', Form.type);
                        return [4 /*yield*/, this.database.clear()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        if (this.activeStep === 0) {
                            sessionStorage.setItem('name', Form.getValue('name'));
                        }
                        return [2 /*return*/];
                }
            });
        }); })
            .catch(function (error) {
            var _a;
            event.preventDefault();
            (_a = error.inner) === null || _a === void 0 ? void 0 : _a.forEach(function (error) {
                var fieldWrap = Form.getFieldWrap(error.path);
                var fieldError = fieldWrap.querySelector("[".concat(constants_1.DATA_FORM_FIELD_ERROR, "]"));
                Form.setError(error, fieldWrap, fieldError);
            });
            _this.revalidateInputs();
        });
    };
    Form.setError = function (error, fieldWrap, fieldError) {
        fieldError.innerHTML = "<p>".concat(error.message, "</p>");
        fieldError.classList.remove('d-none');
        fieldWrap.classList.add('has-error');
        console.warn(error);
    };
    Form.getChecked = function (string) {
        var checkbox = this.getField(string);
        return checkbox ? checkbox.checked : false;
    };
    Form.getFiles = function (string, target) {
        var input = this.getField(string);
        var FileList = [];
        if (target) {
            input = target;
        }
        if (!input)
            return FileList;
        for (var i = 0; i < input.files.length; i++) {
            FileList.push(input.files[i]);
        }
        return FileList;
    };
    Form.getValue = function (string) {
        var field = this.getField(string);
        return field ? field.value : '';
    };
    return Form;
}(abstractComponent_1.default));
exports.default = Form;
